/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

export enum EntityType {
    HOLE_PATTERN = 'HOLE_PATTERN',
    SLOT = 'SLOT',
    ARC = 'ARC',
    ARC_PAIR = 'ARC_PAIR',
    OBROUND = 'OBROUND',
    POINT = 'POINT',
    LINE = 'LINE',
    DIRECTION = 'DIRECTION',
    FACE = 'FACE',
    PLANE = 'PLANE',
    TRANSFORM = 'TRANSFORM',
}

export enum HolePatternType {
    SLOT = 'SLOT',
    HOLE = 'HOLE',
}

export enum EntityEvalDetails {
    OK = 'OK',
    CHILD_FAILURE = 'CHILD_FAILURE',
    MULTIPLE_MATCHES = 'MULTIPLE_MATCHES',
    NO_MATCHES = 'NO_MATCHES',
    GEOMETRIC_DEGENERACY = 'GEOMETRIC_DEGENERACY',
}

export enum TokenCategory {
    CONSTANT = 'CONSTANT',
    RANGE_CONNECTOR = 'RANGE_CONNECTOR',
    NEGATIVE_SIGN_DASH = 'NEGATIVE_SIGN_DASH',
    UNIT = 'UNIT',
    PREDICATE_DESCRIPTOR = 'PREDICATE_DESCRIPTOR',
    ENTITY_DEF = 'ENTITY_DEF',
    CONNECTIVE = 'CONNECTIVE',
    MAXIMIZER_DESCRIPTOR = 'MAXIMIZER_DESCRIPTOR',
    MAXIMIZER_QUANTIFIER = 'MAXIMIZER_QUANTIFIER',
    PAREN_BRACKET = 'PAREN_BRACKET',
    IGNORED = 'IGNORED',
    UNKNOWN = 'UNKNOWN',
}

export enum threedMode {
    VIEW,
    DATUM,
    SUBCAT,
    RULE,
    DATA_MANAGER,
}
